import http from '../../libs/http'
import miniToastr from 'mini-toastr'

export default {
    state: {
        loading: true,
        rolesError: false,
        rolesList: [],
        permissions:[],
        rolesPagination: []
    },
    mutations: {
        SET_PERMISSIONS(state, value) {
            state.permissions = (value);
        },
        SET_ROLES_LIST(state, value) {
            state.rolesList = (value);
        },
    },
    actions: {
        getAllRoles({commit, state}, payload = {}) {
            let data = http.route('roles').get({...payload});
            data.then(res => {
                if (!res.isError) {
                    commit('SET_ROLES_LIST', res.data);
                    // commit('setUsersPagination', res.pagination);
                } else {
                    // commit('setUserError', res.errorMessage);
                }
                return res;
            });
        },
        getPermissions({commit, state}, payload = {}) {
            let data = http.route('roles/permissions').get({});
            data.then(res => {
                if (!res.isError) {
                    commit('SET_PERMISSIONS', res.data);
                } else {

                }
                return res;
            });
        },
        async addRole({commit, state}, payload = {}) {
            let data = [];
            try {
                data = await http.route('role').post({...payload});
            } catch (e) {
                console.error(e.message);
            }
            return data;
        },
        async editRole({commit, state}, payload = {}) {

            let data = await http.route(`role/${payload.id}`).patch({...payload});
            if (!data.isError) {
                // commit('setUser', res.data);
            } else {
                //commit('setUserError', data.errorMessage);
            }
            return data;
        },

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/roles.js